export const TIMETABLE_DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
export const TIMETABLE_DAY_COUNT = 7
export const TIMETABLE_BLOCK_MINUTES = 5
export const TIMETABLE_BLOCKS_PER_DAY = 24 * 60 / TIMETABLE_BLOCK_MINUTES
export const TIMETABLE_TOTAL_BLOCKS = TIMETABLE_DAY_COUNT * TIMETABLE_BLOCKS_PER_DAY

export const createFilledTimetableBlocks = (fill = '0') => String(fill === '1' ? '1' : '0').repeat(TIMETABLE_TOTAL_BLOCKS)

export const sanitizeTimetableBlocks = value => {
    if (typeof value === 'string') {
        const cleaned = value.replace(/[^01]/g, '')

        if (cleaned.length >= TIMETABLE_TOTAL_BLOCKS)
            return cleaned.slice(0, TIMETABLE_TOTAL_BLOCKS)

        return cleaned.padEnd(TIMETABLE_TOTAL_BLOCKS, '0')
    }

    if (Array.isArray(value)) {
        if (value.length === TIMETABLE_TOTAL_BLOCKS)
            return value.map(entry => entry ? '1' : '0').join('')

        if (value.every(entry => Number.isInteger(Number(entry)))) {
            const blocks = createFilledTimetableBlocks().split('')

            value.forEach(entry => {
                const index = Number(entry)

                if (index >= 0 && index < TIMETABLE_TOTAL_BLOCKS)
                    blocks[index] = '1'
            })

            return blocks.join('')
        }
    }

    return createFilledTimetableBlocks()
}

export const normalizeTimetable = value => {
    let rawValue = value

    if (typeof rawValue === 'string') {
        try {
            rawValue = JSON.parse(rawValue)
        }
        catch {
            rawValue = { blocks: rawValue }
        }
    }

    rawValue = rawValue && typeof rawValue === 'object' ? rawValue : {}

    return {
        enabled: Boolean(rawValue.enabled),
        useFiveMinuteBlocks: rawValue.useFiveMinuteBlocks !== false,
        blocks: sanitizeTimetableBlocks(rawValue.blocks ?? rawValue.activeBlocks)
    }
}

export const countActiveTimetableBlocks = value =>
    normalizeTimetable(value).blocks.split('').reduce((count, entry) => count + (entry === '1' ? 1 : 0), 0)
